import { EntityListView } from '../components/EntityListView';

export function TomadoresView({ tomadores, empresas, unidades = [], loading, onAdd, onEdit, onDelete }) {
  return (
    <EntityListView
      title="Tomadores"
      subtitle="Clientes que receberão as notas fiscais"
      items={tomadores}
      loading={loading}
      addLabel="Novo tomador"
      emptyText="Nenhum tomador cadastrado"
      onAdd={onAdd}
      onEdit={onEdit}
      onDelete={onDelete}
      columns={[
        { key: 'nome_fantasia', label: 'Nome', render: (t) => (
          <div>
            <div style={{ fontWeight: 600 }}>{t.nome_fantasia || t.razao_social}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{t.razao_social}</div>
          </div>
        )},
        { key: 'cnpj', label: 'CNPJ', render: (t) =>
          <span className="font-mono" style={{ fontSize: 12 }}>{t.cnpj}</span> },
        { key: 'empresa_id', label: 'Empresa vinculada', render: (t) => {
          if (!t.empresa_id) {
            return <span className="chip" style={{
              background: 'var(--surface-2)', color: 'var(--ink-2)',
              borderColor: 'var(--border-2)', fontStyle: 'italic',
            }}>Cliente em todas</span>;
          }
          const e = empresas.find(x => x.id === t.empresa_id);
          return e ? <span className="chip" style={{
            background: 'var(--primary-soft)', color: 'var(--primary)',
            borderColor: 'var(--primary-line)',
          }}>{e.nome_fantasia}</span> : '—';
        }},
        { key: 'unidade_negocio_id', label: 'Unidade', render: (t) => {
          if (!t.unidade_negocio_id) return <span style={{ color: 'var(--muted)' }}>—</span>;
          const u = unidades.find(x => x.id === t.unidade_negocio_id);
          if (!u) return <span style={{ color: 'var(--muted)' }}>—</span>;
          return <span className="chip" style={{
            background: 'var(--surface-2)', color: 'var(--ink-2)',
            borderColor: 'var(--border-2)',
          }}>{u.nome}</span>;
        }},
        { key: 'cidade', label: 'Cidade/UF', render: (t) => `${t.cidade || '—'}/${t.uf || '—'}` },
      ]}
    />
  );
}
